import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { AuthFacadeService } from '@ib-core/services/auth-facade.service';
import { AuthHttpService } from '@ib-core/services/auth-http.service';
import { NavigationService } from '@ib-core/services/navigation.service';
import { MatSnackBarService } from '@ib-core/services/snackbar.service';
import { UiTouchscreenService } from '@ib-core/services/ui-touchscreen.service';
import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
import { IB_ROUTES } from '@ib-enums/routes.enum';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { ConfirmValidator } from '@ib-shared/validation/confirm.validator';
import {
  PASSWORD_SPECIFIC_SYMBOLS,
  passwordValidators,
} from '@ib-shared/validation/validators-password';

import { SIGN_UP_FIELDS } from '../../sign-up/enums/sign-up-fields.enum';

@Component({
  selector: 'ib-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent
  extends AbstractBaseComponent
  implements OnInit
{
  public PASSWORD_SPECIFIC_SYMBOLS = PASSWORD_SPECIFIC_SYMBOLS;
  public showPassw = false;
  public showPasswRepeat = false;
  public form: FormGroup;
  public loading = false;
  public checkCodeLoading = true;
  public SIGN_UP_FIELDS = SIGN_UP_FIELDS;
  public LOGIN_PATH = '/login';
  // public LOGIN_PATH = NavigationService.getRouteSegmentsByRoute(
  //   IB_ROUTES.LOGIN,
  // );
  public checkCodeError = false;
  public passwordReseted = false;

  constructor(
    private actRoute: ActivatedRoute,
    public tsS: UiTouchscreenService,
    private fb: FormBuilder,
    private navS: NavigationService,
    private authFacadeS: AuthFacadeService,
    private snackbarS: MatSnackBarService,
    private authHttpS: AuthHttpService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.authHttpS
      .checkResetPasswordCode({ code: this.actRoute.snapshot.params['code'] })
      .subscribe({
        next: () => {
          this.checkCodeLoading = false;
        },
        error: () => {
          this.checkCodeError = true;
          this.checkCodeLoading = false;
        },
      });
    // todo check if code valid
    this.form = this.fb.group({
      [SIGN_UP_FIELDS.PASSWORD]: ['', [...passwordValidators]],
      [SIGN_UP_FIELDS.PASSWORD_REPEAT]: ['', [Validators.required]],
    });

    this.form.addValidators([
      ConfirmValidator({
        ctrlName: SIGN_UP_FIELDS.PASSWORD,
        repeatCtrlName: SIGN_UP_FIELDS.PASSWORD_REPEAT,
        errorName: FORM_ERRORS.PASSWORD_MATCHING,
      }),
    ]);
  }

  login(): void {
    this.navS.goToRoute(IB_ROUTES.LOGIN);
  }

  submit(): void {
    this.loading = true;
    this.authFacadeS
      .resetPassword({
        code: this.actRoute.snapshot.params['code'],
        newPassword: this.form.get(SIGN_UP_FIELDS.PASSWORD).value,
      })
      .subscribe({
        next: () => {
          this.passwordReseted = true;
          this.loading = false;
          this.snackbarS.show({
            msg: 'Password was reset. Please Sign In with new password',
            type: 'success',
          });
        },
        error: () => {
          this.loading = false;
        },
      });
  }
}
